module.exports = __webpack_public_path__ + "static/media/4ODA18.c004a8b4.jpg";